<template>
<section v-if="bg" :style="'background-image: url(' + bg.image.url + ');'" :class="[block.class, 'has-text-centered hero is-' + bg.config.height, 'attachment-' + bg.config.attachment, block.mode.toLowerCase()]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div :class="['hero-body', {'is-tinty': bg.config.tinty}]">
        <div class="container" :style="'opacity: ' + opacity">
            <h1 ref="title" class="title">{{block.title}}</h1>
            <p v-if="block.content" class="subtitle" v-html="block.content"></p>
        </div>
        <div class="image-copyright has-text-white" v-if="copyright" v-html="copyright"></div>
    </div>
</section>
</template>

<script>
export default {
    name: 'PageHeroImageMode',
    data()
    {
        return {
            opacity     :   1,
            font_size   :   48
        };
    },
    props: ['block'],
    computed    :   {
        bg()
        {
            if (this.block && this.block.background && this.block.background.image && this.block.background.image.url) {
                return this.block.background;
            }
            return null;
        },
        copyright()
        {
            if (this.block && this.block.background && this.block.background.image) {
                return this.block.background.image.copyright;
            }
            return null;
        },
    },
    mounted()
    {
        this.$bus.$on('onWindowScroll', this.handle_text_fade);
        this.$nextTick().then(() => {
            $(window).scroll().resize();
        });
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.handle_text_fade);
    },
    methods     :   {
        recalc()
        {
            this.top_margin = document.querySelector(".navbar-brand").clientHeight;
        },
        handle_text_fade(offset)
        {
            if (!this.block.background.config.text_fade) return false;

            if (offset == 0) {
                this.opacity    =   1;
                return false;
            }

            let n   =   100 - ($(this.$refs.title).offset().top - offset);
            this.opacity    -=   n * 0.001;
            if (this.opacity > 1) {
                this.opacity    =   1;
            } else if (this.opacity < 0) {
                this.opacity    =   0;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/herotypes/PageHeroImageMode.vue